import * as ROUTES from 'Routes'
import { ROOT_URL } from 'gatsby-env-variables'
import { navigate } from 'gatsby'
import Text from 'components/Text'
import Button from 'components/Button'
import ImgStoryblok from 'components/ImgStoryblok'
import getStoryblokImageDimensions from 'utils/getStoryblokImageDimensions'
import router from 'utils/router'
import './LandingPartners.styl'

const LandingPartners = ({ blok, location }) => {
  const renderLogos = () => {
    return blok.partners.map((i) => (
      <div className="item" key={i.id}>
        <ImgStoryblok
          src={i.filename}
          alt={i.alt}
          width={getStoryblokImageDimensions(i.filename).width || 105}
          height={getStoryblokImageDimensions(i.filename).height || 70}
          loading="lazy"
        />
      </div>
    ))
  }

  return (
    <div className="landing-partners">
      {/* <div className="mobile-part">
        <ImgStoryblok
          src={blok.mobile_image.filename}
          alt="Desconto de até 90%"
          loading="lazy"
        />
      </div> */}
      <Text h2 className="partners-top-part">
        {blok.title}
      </Text>
      <div
        className="partners-middle-part"
        data-test="partners-logos-container"
      >
        {renderLogos()}
      </div>
      <div className="partners-bottom-part">
        <Button
          className="button"
          onClick={() => {
            navigate(ROUTES.register.path, {
              state: {
                source_url: location.href,
                mp_uuid: router.getQueryString('mp_uuid'),
              },
            })
          }}
          data-unique="3de050cd-cb37-412b-9a30-f865f3760327"
          data-test="partners-consult-button"
          data-make-location="lp"
          data-make-position="lp-cta"
          data-make-actionoutcome="check_cpf"
          data-make-element="button"
          data-make-outboundurl={`${ROOT_URL}${ROUTES.register.path}`}
        >
          {blok.button_text}
        </Button>
      </div>
    </div>
  )
}

export default LandingPartners
